module.exports = __webpack_public_path__ + "media/images/shark/SharkMainImage-p-500-a98d5218198ecacc47c91918686db46d.jpg";